export default "https://cdn.questicon.mathletics.com/assets/images/kraken_mountain-5bb71aa228e088b7f36b9e2bf7f696f6.png";